import { render, staticRenderFns } from "./clueDetails.vue?vue&type=template&id=52d2ed9a&scoped=true&"
import script from "./clueDetails.vue?vue&type=script&lang=js&"
export * from "./clueDetails.vue?vue&type=script&lang=js&"
import style0 from "./clueDetails.vue?vue&type=style&index=0&id=52d2ed9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2ed9a",
  null
  
)

export default component.exports